import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { PageLoader, PageHeader, EmptyState, Badge } from "@/components/common";
import { Search as SearchIcon } from "lucide-react";

export default function SearchPage() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const q = sp.get("q") || "";
  const { data, isLoading } = useQuery({ queryKey: ["search", q], queryFn: () => get(`/search?q=${encodeURIComponent(q)}`), enabled: !!q });
  if (isLoading) return <PageLoader />;
  const empty = data && Object.values(data).every((v) => !v || v.length === 0);
  return (
    <div>
      <PageHeader title={`Search: "${q}"`} />
      {empty ? <EmptyState icon={SearchIcon} title="No results found" hint="Try a different keyword." /> : (
        <div className="space-y-6">
          <Group title="Courses" items={data?.courses} onClick={(i) => nav(`/app/courses/${i.id}`)} render={(i) => i.title} />
          <Group title="Tests" items={data?.tests} render={(i) => <><span>{i.title}</span> <Badge tone="indigo">{i.test_type}</Badge></>} />
          <Group title="Current Affairs" items={data?.current_affairs} render={(i) => i.title} />
          <Group title="Students" items={data?.students} onClick={(i) => nav(`/admin/students/${i.id}`)} render={(i) => `${i.name} · ${i.email}`} />
          <Group title="Teachers" items={data?.teachers} onClick={(i) => nav(`/admin/teachers/${i.id}`)} render={(i) => `${i.name} · ${i.email}`} />
        </div>
      )}
    </div>
  );
}
function Group({ title, items, render, onClick }) {
  if (!items || items.length === 0) return null;
  return <div><h3 className="font-display font-bold text-slate-900 mb-2">{title}</h3><div className="space-y-2">{items.map((i, k) => <div key={k} onClick={() => onClick?.(i)} className={`bg-white border border-slate-200 rounded-lg px-4 py-3 text-sm text-slate-700 flex items-center gap-2 ${onClick ? "cursor-pointer card-hover" : ""}`}>{render(i)}</div>)}</div></div>;
}
